import { startOfLocalDay } from "@racoon/lib";

export function getUtcDayRange(date?: Date): { start: string; end: string } {
  const startDate = startOfLocalDay(date ?? new Date());
  const endDate = new Date(startDate);
  endDate.setHours(23, 59, 59, 999);

  return {
    start: startDate.toISOString(),
    end: endDate.toISOString(),
  };
}
